import React from 'react';
import { Settings, Car, Plane } from 'lucide-react';

const capabilities = [
  { name: 'CloudSuite™ Industrial Enterprise', icon: Settings },
  { name: 'CloudSuite™ Automotive', icon: Car },
  { name: 'CloudSuite™ Aerospace & Defense', icon: Plane },
];

const capabilitiesVideo = 'https://res.cloudinary.com/djaejg3nn/video/upload/v1791796970/infor_video_afb0lk.webm';

const inforServices = ['Infor LN', 'Infor M3', 'Infor MES', 'Infor CSI', 'Infor OS', 'Infor WMS'];

export default function InforCapabilities() {
  return (
    <section
      className="rounded-t-3xl border-t px-4 py-14 sm:px-6 sm:py-12 lg:px-10 lg:py-16 xl:px-16"
      style={{ backgroundColor: '#FFFFFF', borderColor: '#E5E7EB' }}
      aria-labelledby="infor-capabilities-heading"
    >
      <div className="mx-auto grid max-w-[1740px] grid-cols-1 items-start gap-10 lg:grid-cols-2 lg:gap-14 xl:gap-20">
        <div className="min-w-0">
          <h2
            id="infor-capabilities-heading"
            className="text-2xl font-medium leading-tight tracking-tight sm:text-3xl xl:text-4xl"
            style={{ color: '#000000' }}
          >
            Our Infor Capabilities
          </h2>
          <p
            className="mt-4 text-sm leading-relaxed sm:text-base lg:mt-6"
            style={{ color: '#475569' }}
          >
            Delivering tailored business-fit Infor solutions and support for optimal business performance.
          </p>

          <h3
            className="mt-7 text-xl font-medium lg:mt-8 xl:text-2xl"
            style={{ color: '#000000' }}
          >
            Infor CloudSuite
          </h3>
          <ul className="m-0 mt-4 list-none p-0">
            {capabilities.map(({ name, icon: Icon }) => (
              <li
                key={name}
                className="flex items-center gap-3 border-b py-3"
                style={{ borderColor: '#E2E8F0' }}
              >
                <Icon
                  className="h-5 w-5 shrink-0"
                  strokeWidth={1.5}
                  style={{ color: '#000000' }}
                  aria-hidden="true"
                />
                <span
                  className="text-sm font-medium leading-snug sm:text-base xl:text-lg"
                  style={{ color: '#334155' }}
                >
                  {name}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-label="Our Infor capabilities overview"
          className="h-auto w-full rounded-3xl"
        >
          <source src={capabilitiesVideo} type="video/webm" />
          Your browser does not support embedded video.{' '}
          <a href={capabilitiesVideo}>Watch the Infor capabilities video.</a>
        </video>
      </div>

      <ul
        aria-label="Infor services we provide"
        className="mx-auto mb-0 mt-10 grid max-w-[1740px] list-none grid-cols-2 gap-x-6 gap-y-6 p-0 sm:mt-12 sm:grid-cols-3 lg:mt-16 lg:grid-cols-6 lg:gap-8"
      >
        {inforServices.map((service) => (
          <li
            key={service}
            className="py-3 text-center text-base font-semibold lg:text-left xl:text-lg"
            style={{ color: '#000000' }}
          >
            {service}
          </li>
        ))}
      </ul>
    </section>
  );
}
